/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import VectorMap from "../../../component/VectorMap";
import countryflagSvg from "../../../../public/countryflag.svg";
import vieweyeicoSvg from "../../../../public/vieweyeico.svg";
import AddCountry from "./AddEditCountry";
import MasterService from "../../../../services/MasterService";
import { Link } from "react-router-dom";
import { showLoading } from "react-global-loading";
class ViewCountries extends React.Component {
  constructor(props) {
    super(props);
    showLoading(true);
    this.state = {
      countryList: [], searchedCountry: [], hoveredCountry: ''
    };
  }

  componentDidMount = () => {
    this.getAyushCountries();
  };

  getAyushCountries = () => {
    MasterService.getAyushCountries()
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ countryList: result, searchedCountry: result });

        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  findCountry = (e) => {
    const searchedCountry = this.state.countryList.filter((item) => item.blogname.toLowerCase().includes(e.target.value));
    this.setState({ searchedCountry })
  }

  render() {
    const { searchedCountry, hoveredCountry } = this.state;
    return (
      <>
        <div className="container-fluid" id="main">
          <nav aria-label="breadcrumb">
            {/* <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="#">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">View Countries</li>
            </ol> */}
          </nav>
          <hr></hr>
          <div className="row">
            <div className="col-12">
              <h3>
                <b>Countries under AGP</b>
              </h3>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <ul className="nav nav-tabs admintabs" id="myTab">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="view-all-countriess-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#view-all-countriess-pane"
                    type="button"
                    role="tab"
                    aria-controls="view-all-countriess-pane"
                    aria-selected="true"
                  >
                    View Countries
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="add-new-country-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#add-new-country-pane"
                    type="button"
                    role="tab"
                    aria-controls="add-new-country-pane"
                    aria-selected="false"
                  >
                    Add New Country
                  </button>
                </li>
              </ul>
              <div
                className="tab-content bg-white pt-2 px-4 mt-2"
                id="myTabContent"
              >
                <div
                  className="tab-pane fade show active"
                  id="view-all-countriess-pane"
                >
                  {/* <div className="row">
                    <div className="col-12">
                      <h4 className="bg-body-tertiary p-2">Search For Country Below</h4>
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="col-lg-4 col-md-12 bg-color-portal mt-3 countries lfbrd">
                      <form role="search" className="py-3 px-3 formcon">
                        <label
                          htmlFor="productname"
                          id="searchcountry"
                          className="bldlbl"
                        >
                          Search country name
                        </label>
                        <input
                          className="form-control me-2 "
                          placeholder="Search country by Name"
                          aria-labelledby="searchcountry"
                          onKeyUp={(e) => this.findCountry(e)}
                        />
                      </form>
                      <ul className="details m-0 px-2 clstsc">
                        {searchedCountry.map((item, index) => (
                          <Link
                            key={index}
                            to={{
                              pathname: "/super/countries-details",
                              search: `?id=${item.id}`,
                              state: { countryData: item },
                            }}
                          >
                            
                            <li className="detail-group mt-2 d-flex align-items-center justify-content-between" onMouseEnter={() => this.setState({ hoveredCountry: item })}>
                              <div className="d-flex align-items-center justify-content-between">
                                {/* <img src={countryflagSvg} className="d-block" alt="country" /> */}
                                <span className="ms-2">{item.blogname}</span>
                              </div>
                              {/* <div className="details-img">
                                <img src={vieweyeicoSvg} className="d-block" alt="view country" />
                              </div> */}
                            </li>
                          </Link>
                        ))}
                      </ul>
                    </div>

                    <div className="col-lg-8 ">
                      <div className="countrymap">
                        <VectorMap className="w-100" highlightCountry={hoveredCountry} />
                      </div>
                    </div>
                  </div>
                </div >

                <div className="tab-pane fade" id="add-new-country-pane">
                  <AddCountry />
                </div>
              </div >
            </div >
          </div >
        </div >
      </>
    );
  }
}
export default ViewCountries;
